import React from 'react';
import Lottie from 'lottie-react';
import loader from '../../assets/loader.json';
import stl from './Preloader.module.css';

export const Preloader = () => {
    return (
        <div className={stl.preloader}>
            <Lottie animationData={loader} className={stl.loader} loop />
        </div>
    );
};
